import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard.js';
import DoctorsList from './Doctors_List';
import JuneDoctorsList from './JuneDoctorsList';

import TestCategoriesList from './TestCategories_List';
import Add_CategoryList from './Add_CategoryList.js';
import TestsList from './Tests_List';
import Add_Testslist from './Add_Testslists.js';
import EditDoctor from './EditDoctor';
import EditTest from './EditTest';
import UsersList from './UsersList.js';
import AddUser from './AddUser.js';
import EditUser from './EditUser.js';
import InvoiceGen from './InvoiceGen.js';
import InvoicePrint from './InvoicePrint.js';
import Status from './Status_Approval.js';
import EditTc from './EditTc.js';
import EditTestList from './Edit_Test_List';
import NotFound from './NotFound.js';
import DoctorAttendance from './DoctorAttendance.js';
import AttendanceReports from './AttendanceReports.js';
import ChangePassword from './ChangePassword';
import AddDoctor from './AddDoctor.js';
const App = () => {
     // import ChangePassword1 from './ChangePassword1';
     const [blocked, setBlocked] = useState(false);
     useEffect(() => {
          // If the app is inside an iframe (potential clickjacking attempt)
          if (window.top !== window.self) {
               setBlocked(true); // Set state to block rendering
          }
     }, []);
     return (
          <Router>
               <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/doctors_list" element={<DoctorsList />} />
                    <Route path="/add_doctor" element={<AddDoctor />} />
                    <Route path="/june_doctors_list" element={<JuneDoctorsList />} />
                    <Route path="/testcategories_list" element={<TestCategoriesList />} />
                    <Route path="/add_testcategory" element={<Add_CategoryList />} />
                    <Route path="/tests_list" element={<TestsList />} />
                    <Route path="/add_testslist" element={<Add_Testslist />} />
                    <Route path="/edit_doctor/:id" element={<EditDoctor />} />
                    <Route path="/edit_test/:id/:testId" element={<EditTest />} />
                    <Route path="/users_list" element={<UsersList />} />
                    <Route path="/add_user" element={<AddUser />} />
                    <Route path="/edit_user/:id" element={<EditUser />} />
                    <Route path="/edit_tc/:id" element={<EditTc />} />
                    <Route path="/invoice_gen" element={<InvoiceGen />} />
                    <Route path="/invoice_print" element={<InvoicePrint />} />
                    <Route path="/status" element={<Status />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/edit_test_list/:id" element={<EditTestList />} />
                    <Route path="/change_password" element={<ChangePassword />} />
                    <Route path="/doctorAttendance" element={<DoctorAttendance />} />
                    <Route path="/attendanceReports" element={<AttendanceReports />} />
               </Routes>
          </Router>
     );
};
export default App; // Ensure there is a default export
